<div class="modal-header border-bottom-0">
  <h4 class="modal-title body-bold-16 slate-600">
    {{'general.delete_account_title' | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <app-close-icon></app-close-icon>
  </button>
</div>
<div class="modal-body">
  <div class="form-outline">
    <app-text-input
      id="dPassword"
      name="dPassword"
      type="password"
      [label]="'general.password' | translate"
      [enablePasswordToggle]="true"
      [errorMessage]="'errors.invalid_password' | translate"
      [showError]="controlSubmitAttempt && passwordControl.invalid"
      [formControl]="passwordControl">
    </app-text-input>
  </div>
</div>
<div class="modal-footer border-top-0">
  <div class="actions m-0">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Close click')">
      {{'general.close' | translate}}
    </button>
    <button type="button" class="btn btn-danger" (click)="deleteAccount()">
      {{'general.delete' | translate}}
    </button>
  </div>
</div>
